export enum WebsiteSliderButtonPathTypeEnum {
  Internal = 'internal',
  External = 'external'
}
